import { useMemo } from 'react';
import { useBusinessTime } from '@/hooks/ui/useBusinessTime';
import { ShiftStatusService, createShiftStatusService } from '@/lib/scheduling/shift-status-service';

/**
 * Hook that returns a timezone-aware ShiftStatusService
 * Uses the business timezone to ensure consistent status calculations across all views
 */
export const useShiftStatusService = (): ShiftStatusService => {
  const { businessTimezone } = useBusinessTime();

  return useMemo(() => {
    return createShiftStatusService({}, businessTimezone || 'UTC');
  }, [businessTimezone]);
};
